import { FormattedMessage } from 'react-intl';
import { QUERY_STATE } from '@tmapy/beetlejuice-utils';

import { Table } from '@tmapy/style-guide';

import { DocListItemDmvsDti } from './DocListItemDmvsDti';
import { docListMessages } from './docsMessages';
import { ResponsiblePersonHeader } from './ResponsiblePersonColumn';

import type { DocListResponse } from '../../openapi/types';
import { LoadNextItemsBar } from '../../app/components/LoadNextItemsBar';

export type DocListDmvsDtiProps = {
  docList: DocListResponse[];
  queryState: QUERY_STATE;
  docCount: number | undefined;
  handleNextDocsBtnClick: () => void;
};
export const DocListDmvsDti: React.FC<DocListDmvsDtiProps> = ({
  docList,
  queryState,
  docCount,
  handleNextDocsBtnClick,
}) => {
  return (
    <div className='sg-u-box sg-a-px-2 sg-a-pb-2 sg-u-vs-2'>
      <div className='sg-a-mx--2'>
        <Table isClickable>
          <thead>
            <tr>
              <th className='sg-a-ta-c'>
                <FormattedMessage {...docListMessages.docListColumnState} />
                <br />
                <FormattedMessage {...docListMessages.docListColumnNumber} />
              </th>
              <th>
                <FormattedMessage {...docListMessages.docListColumnName} />
                <br />
                <FormattedMessage {...docListMessages.docListColumnDescription} />
              </th>
              <th>
                <FormattedMessage {...docListMessages.docListColumnPrejimkaType} />
              </th>
              <th className='sg-a-ta-r'>
                <FormattedMessage {...docListMessages.docListColumnCreated} />
                <>
                  <br />
                  <span className='dmx-u-c-cta-red'>
                    <FormattedMessage {...docListMessages.docListColumnClosed} />
                  </span>
                </>
              </th>
              <th>
                <FormattedMessage {...docListMessages.docListColumnDmvsIdPodani} />
              </th>
              <th>
                <FormattedMessage {...docListMessages.docListColumnDmvsSource} />
              </th>
              <th>
                <FormattedMessage {...docListMessages.docListColumnSubjekt} />
              </th>
              <th>
                <FormattedMessage {...docListMessages.docListColumnEditorManager} />
              </th>
              <ResponsiblePersonHeader />
              <th />
            </tr>
          </thead>
          <tbody>
            {docList.map((docItem) => (
              <DocListItemDmvsDti key={docItem.id} {...docItem} />
            ))}
          </tbody>
        </Table>
      </div>
      <LoadNextItemsBar
        count={docList.length}
        total={docCount!}
        queryState={queryState}
        onNextBtnClick={handleNextDocsBtnClick}
      />
    </div>
  );
};
